// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".newSecurityOrganism {\n  width: 35%;\n  height: 50px;\n  align-items: center;\n  justify-content: center;\n  display: flex;\n  border: none;\n  border-radius: 0px;\n  color: #495057;\n  background-color: #eeeeee;\n}\n", ""]);
// Exports
module.exports = exports;
